import React from 'react';

import { useApp } from '../../../context/app-context';
import EventImage from '../../../hooks/useEventSearch/EventImage';
import useLotEvents from '../../../hooks/useLotEvents';
import { Loading } from '../..';
import EventInfo from '../../events/EventInfo';
import EventDates from '../EventDates';

import { StyledContainer } from './styles';
import type { EventDetailsProps } from './types';

export default function EventDetails({ entry, isLoading }: EventDetailsProps) {
  const { bookedDates, isLoading: eventsIsLoading } = useLotEvents(entry.id);
  const { userIsLoading } = useApp();

  return (
    <StyledContainer paddingBottom={32}>
      {eventsIsLoading || isLoading || userIsLoading ? (
        <Loading />
      ) : (
        <>
          <EventImage image={entry.image} location="details" />

          <EventInfo bookedDates={bookedDates} data={entry} />

          <EventDates bookedDates={bookedDates} data={entry} />
        </>
      )}
    </StyledContainer>
  );
}
